"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListOrders = void 0;
const snap_ui_1 = require("@teamsnap/snap-ui");
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const React = __importStar(require("react"));
// Local Imports
const snap_ui_2 = require("@teamsnap/snap-ui");
const react_router_1 = require("react-router");
const installment_preview_1 = require("./installment-preview");
const order_card_1 = __importDefault(require("./order-card"));
const ListOrders = ({ orders, profile }) => {
    const location = (0, react_router_1.useLocation)();
    const history = (0, react_router_1.useHistory)();
    const searchParams = new URLSearchParams(location?.search || '');
    const search = searchParams.get('search');
    const [searchTerm, setSearchTerm] = React.useState(search || '');
    const setSearchTermAndURL = (value) => {
        setSearchTerm(value);
        history.replace({
            search: value ? `?search=${value}` : '',
        });
    };
    const includedInSearch = (order) => {
        if (order.id.toString().includes(searchTerm) ||
            order.orderNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (0, installment_preview_1.getDateString)(order.insertedAt).toLowerCase().includes(searchTerm.toLowerCase())) {
            return true;
        }
        return false;
    };
    const getOrdersToDisplay = () => {
        const sortedOrders = (orders || [])
            .filter((order) => order.status !== 'pending')
            .sort((a, b) => {
            return new Date(b.insertedAt).getTime() - new Date(a.insertedAt).getTime();
        });
        if (searchTerm === '' || !searchTerm) {
            return sortedOrders;
        }
        const filteredOrders = sortedOrders.filter((order) => includedInSearch(order));
        return filteredOrders;
    };
    const ordersToDisplay = getOrdersToDisplay();
    return (React.createElement("div", { style: { maxWidth: '40rem', margin: '0 auto' } },
        React.createElement(snap_ui_2.TooltipProvider, null,
            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true, className: "u-padEndsMd" },
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12 u-flex u-flexJustifyCenter" },
                    React.createElement(snap_ui_1.Input, { type: "text", name: "search", leftIcon: "search", allowClear: true, value: searchTerm, onChange: (e) => setSearchTermAndURL(e.target.value), inputProps: {
                            maxLength: 255,
                        }, "data-testid": "ordersSearchInput" })),
                React.createElement(teamsnap_ui_1.Cell, { mods: "u-padTopMd" }, ordersToDisplay.length === 0 ? (React.createElement("p", { className: "u-textCenter" }, "No orders to display")) : (ordersToDisplay.map((order) => React.createElement(order_card_1.default, { key: order.id, order: order, profile: profile }))))))));
};
exports.ListOrders = ListOrders;
exports.default = exports.ListOrders;
